import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchEmailHistoryList } from "../../apis/emailHistory";

export const fetchEmailHistoryListData = createAsyncThunk(
  "emailHistory/fetchEmailHistoryList",
  async (
    { page, limit }: { page: number; limit: number },
    { rejectWithValue }
  ) => {
    try {
      return await fetchEmailHistoryList(page, limit);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
